import CourseCard from '../CoursesShelf/CardCourse';
import { IShowcaseCourse } from 'interface/showcase';
import Carousel from '../../Carousel';
import { useState, useEffect } from 'react';

import showcaseService from 'services/showcase';

interface IProps {
  title: string;
}

const KeepWatching = (props: Partial<IProps>) => {
  const [courses, setCourses] = useState<IShowcaseCourse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    showcaseService
      .getShowcaseKeepWatching<IShowcaseCourse[]>()
      .then(setCourses)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Carousel
        id='showcase-shelf-keep-watching'
        title={props.title}
        isEmpty={(courses ?? []).length === 0}
        loadingShelf={loading && (courses ?? []).length === 0}
        hasMoreContentToFetch={false}
      >
        {(courses ?? []).map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </Carousel>
    </div>
  );
};

export default KeepWatching;
